<div #sankey class="du-scraii-beeswarm-wrapper" style="font-family: 'Poppins', sans-serif;">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <div style="background-color: #fff;">
        <icon-chart
          [headerConfig]="headerConfig"
          [iconList]="iconList"
          [data]="data"
          [pageKey]="pageKey"
          [heading]="heading"
          [chartName]="'sankeyBeeswarmChart'"
          [config]="canvasRef"
          [expand]="fs"
          [fullscreen]="isFullscreen"
          [item]="item"
          (layerControl)="layerControl($event)"
          (screenChanges)="fullscreenChanges($event)"
        ></icon-chart>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoading" style="height: 250px;"><loading ></loading></div>

      <!-- No Data -->
      <div style="height: 300px; width: auto;" *ngIf="this.data.length == 0 && !isLoading">
        <span class="bg-text">{{ error_name ? error_name: 'There is no data for this time period' }}</span>
      </div>

      <!-- Top Bar -->
      <div class="du-scraii-beeswarm-top-bar" *ngIf="(this.data.length>0) && (chartData || spList.length) && !isLoading">
        <div class="du-scraii-beeswarm-top-bar-left">
          <div class="du-scraii-beeswarm-kpi-block">
            <span class="du-scraii-beeswarm-kpi-label">Cancelled Patients</span>
            <span class="du-scraii-beeswarm-kpi-value">{{ chartData['total'] | number }}</span>
          </div>
          <!-- <div class="kpi-divider"></div> -->
          <!-- <span class="kpi-subtitle">Specialty pharmacy patient flow &amp; time to fill</span> -->
        </div>
        <div class="du-scraii-beeswarm-top-bar-right">
          <div class="du-scraii-beeswarm-legend-section">
            <span class="du-scraii-beeswarm-legend-title">SPECIALTY PHARMACY</span>
            <div class="du-scraii-beeswarm-legend-pills">
              <button *ngFor="let sp of spList"
                class="du-scraii-beeswarm-pill"
                [class.active]="isSPActive(sp.id)"
                [class.dimmed]="isSPDimmed(sp.id)"
                [style.--c]="sp.color"
                [style.--cbg]="sp.color + '18'"
                (click)="toggleSP(sp.id)">
                <span class="du-scraii-beeswarm-pill-dot" [style.background]="sp.color"></span>
                {{ sp.name }} <small>({{ sp.n }})</small>
              </button>
            </div>
          </div>
          <div class="du-scraii-beeswarm-legend-divider"></div>
          <div class="du-scraii-beeswarm-legend-section">
            <span class="du-scraii-beeswarm-legend-title">OUTCOME</span>
            <div class="du-scraii-beeswarm-legend-pills">
              <button *ngFor="let f of fillLegend"
                class="du-scraii-beeswarm-pill"
                [class.active]="isFillNameActive(f.ids)"
                [class.dimmed]="isFillNameDimmed(f.ids)"
                [style.--c]="f.color"
                [style.--cbg]="f.color + '18'"
                (click)="toggleFillName(f.ids)">
                <span class="du-scraii-beeswarm-pill-dot" [style.background]="f.color"></span>
                {{ f.name }} <small>({{ f.n }})</small>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- SVG Chart -->
      <div [style.display]="this.data?.length == 0 ? 'none' : ''" class="du-scraii-beeswarm-chart-container">
        <svg #canvas></svg>

        <!-- Hint -->
        <!-- <div class="lasso-hint" [class.hidden]="!hintVisible">
          Click &amp; drag to lasso select dots <kbd>Esc</kbd> to clear
        </div> -->
      </div>

      <!-- Bubble (dot) tooltip — rendered through DynamicCustomTooltipService -->
      <ng-template #bubbleTooltipTpl>
        <div class="du-scraii-beeswarm-bubble-tooltip" *ngIf="bubbleTooltipData">
          <div class="du-scraii-beeswarm-bubble-tooltip__title" [style.color]="bubbleTooltipData.color">
            {{ bubbleTooltipData.spName }}
          </div>
          <div class="du-scraii-beeswarm-bubble-tooltip__row">
            <span class="du-scraii-beeswarm-bubble-tooltip__label">Patient ID</span>
            <span class="du-scraii-beeswarm-bubble-tooltip__value">{{ bubbleTooltipData.patientId }}</span>
          </div>
          <div class="du-scraii-beeswarm-bubble-tooltip__row">
            <span class="du-scraii-beeswarm-bubble-tooltip__label">Outcome</span>
            <span class="du-scraii-beeswarm-bubble-tooltip__value">{{ bubbleTooltipData.laneName }}</span>
          </div>
          <div class="du-scraii-beeswarm-bubble-tooltip__row">
            <span class="du-scraii-beeswarm-bubble-tooltip__label">Days</span>
            <span class="du-scraii-beeswarm-bubble-tooltip__value du-scraii-beeswarm-bubble-tooltip__value--accent">{{ bubbleTooltipData.days }}</span>
          </div>
          <div class="du-scraii-beeswarm-bubble-tooltip__atrisk" *ngIf="bubbleTooltipData.atRisk">⚠ At risk</div>
        </div>
      </ng-template>

      <!-- Generic node tooltip (SP / HUB / BRIDGE / LANE / sankey link)
           — same look as app-sankey-chart's tooltip -->
      <ng-template #nodeTooltipTpl>
        <div class="du-scraii-beeswarm-node-tooltip" *ngIf="nodeTooltipData">
          <div class="du-scraii-beeswarm-node-tooltip__header">{{ nodeTooltipData.header }}</div>
          <div class="du-scraii-beeswarm-node-tooltip__body">
            <div *ngFor="let item of nodeTooltipData.items" class="du-scraii-beeswarm-node-tooltip__item">
              <div class="du-scraii-beeswarm-node-tooltip__bullet" [style.background-color]="item.bulletColor"></div>
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Lasso Summary Panel — rendered via CDK Overlay anchored at the drop point. -->
      <ng-template #lassoPanelTpl>
        <div class="du-scraii-beeswarm-lasso-panel" *ngIf="lassoPanelData">
          <div class="du-scraii-beeswarm-lasso-panel-inner">
            <div class="du-scraii-beeswarm-lasso-header">
              <span class="du-scraii-beeswarm-lasso-title-badge">Patients Selected</span>
              <span class="du-scraii-beeswarm-lasso-badge">{{ lassoPanelData.count }}</span>
              <button class="du-scraii-beeswarm-lasso-nav-icon du-scraii-beeswarm-lasso-nav-icon--header"
                      type="button"
                      (click)="onLassoAllNav()"
                      title="Navigate to Patient List">
                <svg width="12" height="12" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path d="M3 2 L7 5 L3 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button class="du-scraii-beeswarm-lasso-close" type="button" (click)="clearLasso()">&times;</button>
            </div>

            <div class="du-scraii-beeswarm-lasso-stats">
              <div>
                <strong>{{ lassoPanelData.avgDays }}</strong>
                <small>Avg Days</small>
              </div>
              <div>
                <strong>{{ lassoPanelData.medianDays }}</strong>
                <small>Median Days</small>
              </div>
              <div>
                <strong>{{ lassoPanelData.atRisk }}</strong>
                <small>At Risk</small>
              </div>
            </div>

            <div class="du-scraii-beeswarm-lasso-section">
              <strong>By Specialty Pharmacy</strong>
              <div class="du-scraii-beeswarm-lasso-bar-row" *ngFor="let row of lassoPanelData.bySP">
                <span class="du-scraii-beeswarm-lasso-dot" [style.background]="row.color"></span>
                <span class="du-scraii-beeswarm-lasso-name">{{ row.name }}</span>
                <span class="du-scraii-beeswarm-lasso-count">{{ row.count }}</span>
                <button class="du-scraii-beeswarm-lasso-nav-icon" type="button"
                        (click)="onLassoRowNav('sp', row)"
                        title="Navigate to Patient List">
                  <svg width="12" height="12" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                    <path d="M3 2 L7 5 L3 8" stroke="currentColor" stroke-width="1.6"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <div class="du-scraii-beeswarm-lasso-section">
              <strong>By Outcome</strong>
              <div class="du-scraii-beeswarm-lasso-bar-row" *ngFor="let row of lassoPanelData.byLane">
                <span class="du-scraii-beeswarm-lasso-dot" [style.background]="row.color"></span>
                <span class="du-scraii-beeswarm-lasso-name">{{ row.name }}</span>
                <span class="du-scraii-beeswarm-lasso-count">{{ row.count }}</span>
                <button class="du-scraii-beeswarm-lasso-nav-icon" type="button"
                        (click)="onLassoRowNav('lane', row)"
                        title="Navigate to Patient List">
                  <svg width="12" height="12" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                    <path d="M3 2 L7 5 L3 8" stroke="currentColor" stroke-width="1.6"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

    </article>
  </main>
</div>
